import { mount } from 'svelte'
import BirthdayScheduleForm from '@/components/birthdays/BirthdayScheduleForm.svelte'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('birthdays-form-app')
  if (el) {
    mount(
      BirthdayScheduleForm,
      {
        target: el,
        props: {
        },
      })
  }
})
